import { pathParse } from "svg-path-parse";
import Point from "@/geom/Point";
import BezierPathCommand from "@/geom/BezierPathCommand";

var SVGUtils = {
    parseSVGString: function(svgString) {
        svgString = svgString.replace(/,M/g, "M").replace(/,L/g, "L").replace(/,H/g, "H").replace(/,V/g, "V")
            .replace(/,Q/g, "Q").replace(/,T/g, "T").replace(/,S/g, "S").replace(/,C/g, "C").replace(/,Z/g, "Z");
        const result = [];

        const parseResult = pathParse(svgString).getSegments();

        var cx = 0.0;
        var cy = 0.0;
        var mx = 0.0;
        var my = 0.0;
        var offsetCX = NaN;
        var offsetCY = NaN;
        var pointCX = NaN;
        var pointCY = NaN;
        
        const segments = parseResult.segments;
        for (var i = 0; i < segments.length; i ++) {
             var offsetX = 0.0;
             var offsetY = 0.0;
            
            const segment = segments[i];
            if (segment.length > 0) {
                switch (segment[0]) {
                case 'm':
                    offsetX = cx;
                    offsetY = cy;
                    break;
                case 'M':
                    var arg1 = segment[1];
                    var arg2 = segment[2];
                    cx = mx = (arg1 + offsetX);
                    cy = my = (arg2 + offsetY);
                    result.push(new BezierPathCommand(BezierPathCommand.Type.MOVE_TO_POINT, new Point(cx, cy)));
                    offsetCX = NaN;
                    offsetCY = NaN;
                    break;
                case 'l':
                    offsetX = cx;
                    offsetY = cy;
                    break;
                case 'L':
                    arg1 = segment[1];
                    arg2 = segment[2];
                    if (cx != (arg1 + offsetX) || cy != (arg2 + offsetY)) {
                        cx = arg1 + offsetX;
                        cy = arg2 + offsetY;
                        result.push(new BezierPathCommand(BezierPathCommand.Type.ADD_LINE_TO_POINT, new Point(cx, cy)));
                    }
                    offsetCX = NaN;
                    offsetCY = NaN;
                    break;
                case 'h':
                    offsetX = cx;
                    offsetY = cy;
                    break;
                case 'H':
                    arg1 = segment[1];
                    if (cx != (arg1 + offsetX)) {
                        cx = arg1 + offsetX;
                        result.push(new Point(cx, cy));
                    }
                    offsetX = NaN;
                    offsetY = NaN;
                    break;
                case 'v':
                    offsetX = cx;
                    offsetY = cy;
                    break;
                case 'V':
                    arg1 = segment[1];
                    if (cy != (arg1 + offsetY)) {
                        cy = arg1 + offsetY;
                        result.push(new Point(cx, cy));
                    }
                    offsetCX = NaN;
                    offsetCY = NaN;
                    break;
                case 'q':
                    offsetX = cx;
                    offsetY = cy;
                    break;
                case 'Q':
                    arg1 = segment[1];
                    arg2 = segment[2];
                    var arg3 = segment[3];
                    var arg4 = segment[4];
                    
                    cx = arg3 + offsetX;
                    cy = arg4 + offsetY;
                    offsetCX = arg1 + offsetX;
                    offsetCY = arg2 + offsetY;
                    result.push(new BezierPathCommand(BezierPathCommand.TYPE_ADD_QUAD_CURVE_TO_POINT, new Point(cx, cy), 
                            new Point(offsetCX, offsetCY)));
                    break;
                case 't':
                    offsetX = cx;
                    offsetY = cy;
                    break;
                case 'T':
                    pointCX = offsetX;
                    pointCY = offsetY;
                    arg1 = segment[1];
                    arg2 = segment[2];
                    
                    if (isNaN(offsetCX) && isNaN(offsetCY)) {
                        pointCX = cx - (offsetCX - cx);
                        pointCY = cy - (offsetCY - cy);
                    }
                    
                    cx = arg1 + offsetX;
                    cy = arg2 + offsetY;
                    offsetCX = pointCX;
                    offsetCY = pointCY;
                    result.push(new BezierPathCommand(BezierPathCommand.Type.ADD_QUAD_CURVE_TO_POINT, new Point(cx, cy), new Point(offsetCX, offsetCY)));
                    break;
                case 's':
                    offsetX = cx;
                    offsetY = cy;
                    break;
                case 'S':
                    pointCX = offsetX;
                    pointCY = offsetY;
                    arg1 = segment[1];
                    arg2 = segment[2];
                    arg3 = segment[3];
                    arg4 = segment[4];
                    
                    if (!isNaN(offsetCX) && !isNaN(offsetCY)) {
                        pointCX = cx - (offsetCX - cx);
                        pointCY = cy - (offsetCY - cy);
                    }
                    
                    cx = arg3 + offsetX;
                    cy = arg4 + offsetY;
                    offsetCX = arg1 + offsetX;
                    offsetCY = arg2 + offsetY;
                    result.push(new BezierPathCommand(BezierPathCommand.Type.ADD_CURVE_TO_POINT, new Point(cx, cy), new Point(pointCX, pointCY), new Point(offsetCX, offsetCY)));
                    break;
                case 'c':
                    offsetX = cx;
                    offsetY = cy;
                    break;
                case 'C':
                    arg1 = segment[1];
                    arg2 = segment[2];
                    arg3 = segment[3];
                    arg4 = segment[4];
                    var arg5 = segment[5];
                    var arg6 = segment[6];

                    cx = arg5 + offsetX;
                    cy = arg6 + offsetY;
                    offsetCX = arg3 + offsetX;
                    offsetCY = arg4 + offsetY;
                    result.push(new BezierPathCommand(BezierPathCommand.Type.ADD_CURVE_TO_POINT, new Point(cx, cy), 
                            new Point(arg1+offsetX, arg2+offsetY), new Point(offsetCX, offsetCY)));
                    break;
                case 'z':
                case 'Z':
                    result.push(new BezierPathCommand(BezierPathCommand.Type.CLOSE_PATH));
                    cx = mx;
                    cy = my;
                    offsetCX = NaN;
                    offsetCY = NaN;
                    break;
                default:
                    break;
                }
            }
        }

        return result;
    }
}

export default SVGUtils;